import { createFileRoute } from '@tanstack/react-router';

import { automaticPixHistorySearch, bankAccountAutomaticPixHistoryScreen, loadBankAccountMessages, loadBankAccountScreens } from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

// Histórico de autorizações do Pix Automático (`router.tsx:531-536`), com o filtro `pxa_status` só aqui.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico')({
  validateSearch: automaticPixHistorySearch,
  staticData: { screen: bankAccountAutomaticPixHistoryScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountAutomaticPixHistoryScreen'),
});
